import React from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'

import actions from 'redux-auto'
import Button from '../a/Button'
import ControlsGroup from './ControlsGroup'
import IconButton from '../a/IconButton'
import {LoadingButton} from '#components/m/LoadingButton'

/* eslint-disable */
if (process.env.NODE_ENV !== 'test') ReactModal.setAppElement('#azubiguide')

/* eslint-enable */

class Modal extends React.Component {
  constructor() {
    super()

    this.state = {
      showModal: false,
      callbackIsExecuting: false,
    }

    this.handleOpenModal = this.handleOpenModal.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleConfirm = this.handleConfirm.bind(this)
  }

  handleOpenModal() {
    this.setState({showModal: true})
  }

  handleCloseModal() {
    this.setState({showModal: false})
  }

  handleConfirm() {
    this.setState({callbackIsExecuting: true}, async () => {
      try {
        await this.props.confirmCallback()
      } catch (e) {
        actions.error.writeError({error: e})
      }
      this.setState({showModal: false, callbackIsExecuting: false})
    })
  }

  render() {
    const {
      children,
      confirmButtonDisabled,
      confirmCallback,
      confirmText,
      confirmLoadingText,
      closeButtonText,
      id,
      modifier,
      trigger,
      hasCloseButton,
      hasCloseIcon,
      onAfterOpen,
    } = this.props

    return (
      <div className="modal__wrap">
        <div
          data-testid="modalTrigger"
          role="button"
          tabIndex={0}
          onKeyPress={this.handleOpenModal}
          onClick={this.handleOpenModal}
        >
          {trigger}
        </div>
        <ReactModal
          ariaHideApp={false}
          isOpen={this.state.showModal}
          onAfterOpen={onAfterOpen}
          shouldCloseOnOverlayClick
          contentLabel="Minimal Modal Example"
          className={`modal modal--${modifier}`}
          overlayClassName="modal__overlay"
        >
          <div data-testid="modalContentWrapper" className="modal__content-wrapper">
            {hasCloseIcon && (
              <div className="modal__closeButton">
                <IconButton event={this.handleCloseModal} icon="close" />
              </div>
            )}
            {children}
            <ControlsGroup>
              {hasCloseButton && (
                <Button
                  testid="modalCancelButton"
                  event={this.handleCloseModal}
                  text={closeButtonText || 'Abbrechen'}
                  variant="secondary"
                  id={`modalCancelButton-${id}`}
                />
              )}
              {confirmCallback && (
                <LoadingButton
                  isLoading={this.state.callbackIsExecuting}
                  id="modalConfirmButton"
                  testid="modalConfirmButton"
                  disabled={confirmButtonDisabled}
                  event={this.handleConfirm}
                  text={confirmText || 'OK'}
                  loadingText={confirmLoadingText || confirmText || 'OK'}
                  variant="primary"
                />
              )}
            </ControlsGroup>
          </div>
        </ReactModal>
      </div>
    )
  }
}

Modal.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  confirmCallback: PropTypes.func,
  confirmText: PropTypes.string,
  confirmLoadingText: PropTypes.string,
  closeButtonText: PropTypes.string,
  trigger: PropTypes.node,
  modifier: PropTypes.string,
  confirmButtonDisabled: PropTypes.bool,
  hasCloseButton: PropTypes.bool,
  hasCloseIcon: PropTypes.bool,
  onAfterOpen: PropTypes.func,
}

export default Modal
